<template>
  <div style="width: 100%; margin: auto; text-align: center;">
    <h1>I will be a {{ $route.name }} page soon...</h1>
  </div>
</template>

<script lang="ts" setup>
</script>
